import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
    teams: null,
    volunteers: null,
    loading: false,
    error: null,
    saving: false,
};

const mutations = {
    SET_TEAMS(state, data) {
        state.teams = data;
    },
    SET_VOLUNTEERS(state, data) {
        state.volunteers = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_SAVING(state, value) {
        state.saving = value;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

const actions = {
    async fetchWorkgroupTeams({ commit }, workgroupid) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.get(
                `/activity-workgroup-teams/workgroup/${workgroupid}`
            );

            const data = response.data?.output || [];
            commit("SET_TEAMS", data);

            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch workgroup teams");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async editWorkgroupTeam(
        { commit },
        { workgroupid, locationid, teamid, teamname, useridsarray, cmd = "editteam" }
    ) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post(`/manageworkgroupajax`, {
                cmd,
                workgroupid,
                locationid,
                teamid,
                teamname,
                useridsarray,
            });

            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to edit team");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },

    async saveTeamSequence(
        { commit },
        { workgroupid, locationid, teamidsarray }
    ) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post(`/manageworkgroupajax`, {
                cmd: "saveteamsequence",
                workgroupid,
                locationid,
                teamidsarray,
            });

            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to save team sequence");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },

    async addWorkgroupTeam(
        { commit },
        { workgroupid, locationid, teamname, useridsarray }
    ) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post(`/manageworkgroupajax`, {
                cmd: "addteam",
                workgroupid,
                locationid,
                teamname,
                useridsarray,
            });

            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to add team");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },

    async fetchSkillVolunteers({ commit }, skillId) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.get(`/skills/${skillId}/volunteers`);
            const data = response.data;

            commit("SET_VOLUNTEERS", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch skill volunteers");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async deleteWorkgroupTeam(
        { commit },
        { workgroupid, locationid, teamid, teamname }
    ) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post(`/manageworkgroupajax`, {
                cmd: "deleteteam",
                workgroupid,
                locationid,
                teamid,
                teamname,
            });

            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to delete team");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },
};

const getters = {
    workgroupTeams: (state) => state.teams,
    skillVolunteers: (state) => state.volunteers,
    workgroupTeamsLoading: (state) => state.loading,
    workgroupTeamsSaving: (state) => state.saving,
    workgroupTeamsError: (state) => state.error,
};

export default {
    state,
    mutations,
    actions,
    getters,
};